import { render } from "./BarcodeScanSave.vue?vue&type=template&id=e87b625e"
import script from "./BarcodeScanSave.vue?vue&type=script&lang=js"
export * from "./BarcodeScanSave.vue?vue&type=script&lang=js"
script.render = render

export default script